var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9167 14.061H1.08333C0.485331 14.061 0 13.5756 0 12.9776C0 12.3796 0.485331 11.8943 1.08333 11.8943H24.9167C25.5147 11.8943 26 12.3796 26 12.9776C26 13.5756 25.5147 14.061 24.9167 14.061Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9167 5.75529H1.08333C0.485331 5.75529 0 5.26996 0 4.67196C0 4.07395 0.485331 3.58862 1.08333 3.58862H24.9167C25.5147 3.58862 26 4.07395 26 4.67196C26 5.26996 25.5147 5.75529 24.9167 5.75529Z",
    fill: "currentcolor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9167 22.3664H1.08333C0.485331 22.3664 0 21.881 0 21.283C0 20.685 0.485331 20.1997 1.08333 20.1997H24.9167C25.5147 20.1997 26 20.685 26 21.283C26 21.881 25.5147 22.3664 24.9167 22.3664Z",
    fill: "currentcolor"
  })));
}

export default SvgMenu;